import type { FormDataOf } from '../../../../types/templates';
import { macroSacaTuTarjeta } from '..';

type FormData = FormDataOf<typeof macroSacaTuTarjeta>;

export const shouldShowField = (fieldKey: string, formData: FormData, _creativityType: string): boolean => {
  if (fieldKey === 'cta_text') {
    const ctaEnabled = formData.cta_enabled;
    return ctaEnabled === true || ctaEnabled === 'si';
  }

  if (fieldKey === 'subheadline') {
    const v = formData.subheadline_enabled;
    return v === true || v === 'si';
  }

  return true;
};
